/* My Acre option card compare table (2026-09-17, Claude). Companion to snippets/ma-option-cards.liquid.
   Only loaded when an option's custom.option_cards entry carries a "compare" block.

   One job: keep the highlighted row in step with the card the shopper has chosen, so the
   table always answers "how does my choice compare with the others". Read-only on the
   theme's own radios. */
(function () {
  function boot() {
    var tables = document.querySelectorAll('[data-ma-cmp]');
    Array.prototype.forEach.call(tables, function (cmp) {
      if (cmp.dataset.maCmpBound) return;
      cmp.dataset.maCmpBound = '1';
      var fs = cmp.closest('[data-ma-cards]');
      if (!fs) return;
      var container = fs.closest('[data-product-options-container]') || document;

      function sync() {
        var on = fs.querySelector('input.ma-option-value__input:checked');
        var val = on ? on.value : null;
        Array.prototype.forEach.call(cmp.querySelectorAll('tr[data-ma-cmp-value]'), function (tr) {
          tr.classList.toggle('is-selected', tr.getAttribute('data-ma-cmp-value') === val);
        });
      }

      container.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.classList && t.classList.contains('ma-option-value__input')) sync();
      });
      sync();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();